import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  apartmentSchema,
  getApartmentSchemaWithAdditionalFields,
} from "./apartment";
import { getHoldingSchemaAdditionalFields, holdingSchema } from "./holding";

export const holdingWithApartmentSchema = holdingSchema.extend({
  apartment: apartmentSchema,
});

export type HoldingWithApartment = z.infer<typeof holdingWithApartmentSchema>;

export function getHoldingWithApartmentSchemaWithAdditionalFields(additionalFields: {
  holding: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
  apartment: typeof additionalDataSchema;
}): typeof holdingWithApartmentSchema {
  return getHoldingSchemaAdditionalFields(additionalFields).extend({
    apartment: getApartmentSchemaWithAdditionalFields(additionalFields),
  });
}
